import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { ReactComponent as Icon } from './csv.svg';

export default () => <SvgIcon component={Icon} viewBox="0 0 48 48" />;
